import { useCallback } from "react"
import ContextualMenu from "components/contextual-menu"
import { SelectedPortfolio } from "helpers/types/instruments/selected"
import { LOADING } from "helpers/data-statuses"
import { usePortfolioMenuItems } from "../hooks/use-resource-menu-items"
import { useAppSelector } from "hooks/redux"
import { useDashboardId } from "../context/dashboard-id"
import { DEFAULT_CORE_STATE } from "../store/core-slice"
import { useCoreActions } from "../hooks/use-core-actions"

function onSuccess() {
  window.location.reload()
}

export function ResourceMenuSwitcher() {
  const dashboardId = useDashboardId()
  const instrument = useAppSelector((s) => s.dashboard.core[dashboardId]?.instrument ?? DEFAULT_CORE_STATE.instrument)
  const { setInstrument } = useCoreActions()
  if (instrument?.type === "PORTFOLIO" && instrument?.experimentId === undefined) {
    return <PortfolioMenu instrument={instrument} setInstrument={setInstrument} />
  }
  return null
}

function PortfolioMenu({ instrument, setInstrument }: PortfolioMenuProps) {
  const onDelete = useCallback(() => setInstrument(null), [setInstrument])

  const [resourceMenuItems, resourceMenuItemsStatus] = usePortfolioMenuItems(instrument, onSuccess, onDelete)
  if (resourceMenuItems) {
    return <ContextualMenu className="dashboard-contextual-menu" items={resourceMenuItems} disabled={resourceMenuItemsStatus === LOADING} />
  }
  return null
}

interface PortfolioMenuProps {
  instrument: SelectedPortfolio
  setInstrument: (instrument: SelectedPortfolio | null) => void
}
